import { Component } from '@angular/core';
import { entraAuthService } from 'src/app/service/auth.service';

import { ModalService } from '../../../service/modal.service';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-common-modal',
  templateUrl: './common-modal.component.html',
  styleUrls: ['./common-modal.component.scss']
})
export class CommonModalComponent {

  constructor(private modalService: ModalService, private entraAuthService: entraAuthService, private msalService: MsalService,
    ) {    
}

  closeModal() {
    this.modalService.closeModal();
  }

  redirectToLogin(): void {
    localStorage.setItem('redirect_url', '/profile');
    this.entraAuthService.initLogin();
  }
  proceedWithLogin() {
    localStorage.setItem('redirect_url', '/profile');
      this.msalService.loginRedirect({
        scopes: ['openid', 'profile', 'email', 'User.Read']
      });
  }
}
